import { call, put, select } from 'redux-saga/effects';

import * as actions from './user-groups.actions';

import * as userGroupService from '../../../resource/user-group/user-group.saga-service';
import * as dialogService from '../../../dialog/dialog.saga-services';

import { userGroupsPageSelectors } from './user-groups.selectors';
import { IUserGroup, IUserGroupCreate, IUserGroupUpdate } from '../../../resource/user-group/user-group.types';

export function* getUserGroups() {
  const userGroups = (yield call(userGroupService.getUserGroups)) as IUserGroup[];

  yield put(
    userGroups?.length
      ? actions.storeUserGroups(userGroups.map((userGroup) => userGroup.id))
      : actions.clearUserGroups(),
  );
}

export function* createUserGroup(userGroup: IUserGroupCreate) {
  const userGroupId = (yield call(userGroupService.createUserGroup, userGroup)) as IUserGroup['id'];

  if (!userGroupId) {
    return;
  }

  const userGroupIds = (yield select(userGroupsPageSelectors.selectUserGroupIds)) as IUserGroup['id'][];
  yield put(actions.storeUserGroups([...userGroupIds, userGroupId]));
  yield call(dialogService.closeDialog, 'userGroupFormDialog');
}

export function* updateUserGroup(id: IUserGroup['id'], name: IUserGroupUpdate['name']) {
  const updateUserGroupId = (yield call(userGroupService.updateUserGroup, id, name)) as IUserGroup['id'];

  if (!updateUserGroupId) {
    return;
  }

  const userGroupIds = (yield select(userGroupsPageSelectors.selectUserGroupIds)) as IUserGroup['id'][];
  yield put(actions.storeUserGroups([...userGroupIds]));
}

export function* clearUserGroupsPageStorage() {
  yield put(actions.clearUserGroups());
}

export function* deleteUserGroup(id: IUserGroup['id']) {
  yield call(userGroupService.deleteUserGroup, id);
  const userGroupIds = (yield select(userGroupsPageSelectors.selectUserGroupIds)) as IUserGroup['id'][];
  const filterDelete = userGroupIds.filter((userGroupId) => userGroupId !== id);
  yield put(actions.storeUserGroups([...filterDelete]));
  yield call(dialogService.closeDialog, 'deleteDialog');
}
